import { render, staticRenderFns } from "./equipment-measures.vue?vue&type=template&id=044b91ff&scoped=true"
import script from "./equipment-measures.vue?vue&type=script&lang=ts"
export * from "./equipment-measures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b91ff",
  null
  
)

export default component.exports